module.exports = __webpack_public_path__ + "img/视频.686c091b.png";